// DO NOT EDIT THIS IS AN AUTOGENERATED FILE;
import * as React from 'react'

interface IconProps {
  color?: string
  size?: string | number
}

const SvgSpeakerMute2 = ({color = 'currentColor', size = 20}: IconProps) => (
  <svg
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    height={size}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 2.75a.75.75 0 0 0-1.178-.616L9.265 6h-3.51L3.19 4.143a.75.75 0 1 0-.88 1.215l2.672 1.934c.049.047.105.088.166.12l11.662 8.445a.75.75 0 1 0 .88-1.214L16 13.419V2.75Zm-1.5 9.583V4.185l-4.572 3.18A.75.75 0 0 1 9.5 7.5H7.826l6.674 4.833Zm-9-2.583a.75.75 0 1 0-1.5 0v2.5c0 .966.784 1.75 1.75 1.75h3.515l5.557 3.866a.75.75 0 0 0 .856-1.232l-5.75-4A.75.75 0 0 0 9.5 12.5H5.75a.25.25 0 0 1-.25-.25v-2.5Z"
    />
  </svg>
)

export default SvgSpeakerMute2
